export default "__VITE_ASSET__kpdQ4yB6__"